import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { mapDtoToGuideline } from 'shared/domain';
import { ServerResponse, TreetopPropertiesProvider } from 'shared/util-common';

import { PaginationWrapperDto, Guideline } from '@treetop/shared/model';

import { GuidelineFullTextFilter, GuidelineSearchResult } from './guideline-search.model';

@Injectable({ providedIn: 'root' })
export class GuidelineSearchHttpService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api/smart-book/full-text`;

  /**
   * Gets search results based on text and page number.
   * @todo Curremtly additional filters are not used!
   * @param filter - Search text and filters
   * @param page - Page number (defaults to 1)
   */
  public getSearchResult(filter: GuidelineFullTextFilter, page = 1, onlySearchHome = false): Observable<ServerResponse<Guideline>> {
    let params = new HttpParams()
      .set('searchText', filter.searchText)
      .set('page', page.toString())
      .set('searchInAllOrganizations', onlySearchHome ? 'false' : 'true');

    if (typeof filter.showShared !== 'undefined') {
      params = params.set('showShared', filter.showShared.toString());
    }

    if (typeof filter.showImported !== 'undefined') {
      params = params.set('showImported', filter.showImported.toString());
    }

    if (Array.isArray(filter.taxonomyIds) && filter.taxonomyIds.length > 0) {
      params = params.set('taxonomyIds', filter.taxonomyIds.join(','));
    }

    return this.http.get<PaginationWrapperDto<GuidelineSearchResult>>(this.baseUrl, { params }).pipe(
      map((response) => ({
        ...response,
        list: response.list.map((dto) => mapDtoToGuideline(dto)),
      })),
    );
  }
}
